import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SavedSearchFilter } from '../../ai2/pages/searchPage/types';

interface DashboardSearchState {
  userSavedFilters: SavedSearchFilter[];
  currentFilters: string[];
  fromNavBar?: boolean;
  savedFiltersInitialized: boolean;
}

const initialState: DashboardSearchState = {
  currentFilters: [],
  userSavedFilters: [],
  fromNavBar: false,
  savedFiltersInitialized: false,
};

export const dashboardSearchSlice = createSlice({
  name: 'dashboardSearch',
  initialState,
  reducers: {
    setCurrentFilter(state, action: PayloadAction<string[]>) {
      state.currentFilters = action.payload;
    },
    resetCurrentFilter(state) {
      state.currentFilters = [];
    },
    setUserSavedFilters(state, action: PayloadAction<SavedSearchFilter[]>) {
      state.userSavedFilters = action.payload;
      state.savedFiltersInitialized = true;
    },
    setFromNavBar(state, action: PayloadAction<boolean>) {
      state.fromNavBar = action.payload;
    },
  },
});

export const {
  setCurrentFilter,
  setUserSavedFilters,
  resetCurrentFilter,
  setFromNavBar,
} = dashboardSearchSlice.actions;
